var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iconAndButton",style:(_vm.buttonStyle),on:{"click":_vm.handleControl}},[_c('i',{class:_vm.icon,style:(_vm.iconStyle)}),_vm._v(_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }